// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1wf4n","bigColWidth":"Table_bigColWidth__YQy-8","biggerColWidth":"Table_biggerColWidth__3Zt-D","row":"Table_row__1WA3l","col":"Table_col__cYhYb"};